<template>
  <v-snackbar
    v-model="notificationShow"
    right
    top
    app
    :color="notificationColor"
    @mouseover="() => {}"
    :timeout="7000"
    transition="slide-x-reverse-transition"
  >
    <span class="font-weight-bold">
      {{ notificationMessage }}
    </span>

    <template v-slot:action="{ attrs }">
      <v-btn small text dark v-bind="attrs" @click="notificationShow = false">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
  export default {
    name: "Notification",
    computed: {
      notificationMessage() {
        return this.$store.state.notification.message;
      },
      notificationType() {
        return this.$store.state.notification.type;
      },
      notificationColor() {
        switch (this.notificationType) {
          case "error":
            return "error";
          case "warning":
            return "warning-orange";
          case "success":
            return "success";
          default:
            return "primary";
        }
      },
      notificationShow: {
        get() {
          return this.$store.state.notification.show;
        },
        set(value) {
          this.$store.commit("notificationShow", value);
        },
      },
    },
  };
</script>

<style lang="scss"></style>
